import { render, staticRenderFns } from "./PartnerAddOrEditContent.vue?vue&type=template&id=6cc9b124&scoped=true"
import script from "./PartnerAddOrEditContent.vue?vue&type=script&lang=js"
export * from "./PartnerAddOrEditContent.vue?vue&type=script&lang=js"
import style0 from "./PartnerAddOrEditContent.vue?vue&type=style&index=0&id=6cc9b124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc9b124",
  null
  
)

export default component.exports